module.exports = __webpack_public_path__ + "static/media/game.a6e97fc9.svg";